import PropTypes from "prop-types";
import { forwardRef } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  CardActions,
  Grid
} from "@mui/material";
import { SubTitle } from "chart.js";

// ==============================|| CUSTOM SUB CARD ||============================== //

const SubCard = forwardRef(
  (
    {
      children,
      content,
      contentClass,
      darkTitle,
      subTittle,
      secondary,
      formTitle,
      sx = {},
      contentSX = {},
      title,
      footerText,
      ...others
    },
    ref
  ) => {
    const theme = useTheme();

    return (
      <Card
        ref={ref}
        sx={{
          border: "1px solid",
          borderColor: theme.palette.primary.light,
          // ":hover": {
          //   boxShadow: "0 2px 14px 0 rgb(32 40 45 / 8%)",
          // },
          ...sx,
        }}
        {...others}
      >
        {/* card header and action */}
        {!darkTitle && title && (
          <CardHeader
            sx={{ p: 1 }}
            title={
              <>
                <Typography variant="h2">{title}</Typography>
                <Typography variant="h3" color={theme.palette.text.Subtitle}>
                  {subTittle}
                </Typography>
              </>
            }
            action={secondary}
          />
        )}

        {!darkTitle && formTitle && (
          <CardHeader
            sx={{ p: 1}}
            title={
              <>
                <Typography variant="h3">{formTitle}</Typography>
                <Typography variant="h3" color={theme.palette.text.Subtitle}>
                  {subTittle}
                </Typography>
              </>
            }
            action={secondary}
          />
        )}
        {darkTitle && title && (
          <CardHeader
            sx={{ p: 1 }}
            title={
              <>
                <Typography variant="h2">{title}</Typography>
                <Typography variant="h5">{subTittle}</Typography>
              </>
            }
            action={secondary}
          />
        )}

        {/* content & header divider */}
        {title && (
          <Divider
            sx={{
              opacity: 1,
              borderColor: theme.palette.primary.light,
            }}
          />
        )}

        {/* card content */}
        {content && (
          <CardContent
            sx={{ p: 1, ...contentSX }}
            className={contentClass || ""}
          >
            {children}
          </CardContent>
        )}
        {!content && children}

        {/* {footerText && (
          <Divider
            sx={{
              opacity: 1,
              borderColor: theme.palette.primary.light,
              // margin: '0 auto',
            }}
          />
        )} */}
        {footerText && (
          // <CardActions sx={{ justifyContent: "center" }}>
          // <Grid sx={{ marginLeft:2 }}>
            <Typography
              variant="subtitle1"
              sx={{
                borderTop: `1px solid ${theme.palette.primary.light}`,
                textAlign: "right",
                fontSize:"12px",
                marginTop: 1,
                marginRight:1,
                marginBottom:1,
                display: "block",
                paddingRight:1
              }}
            >
              {footerText}
            </Typography>
            //  </Grid>
          // </CardActions>
        )}
      </Card>
    );
  }
);

SubCard.propTypes = {
  children: PropTypes.node,
  content: PropTypes.bool,
  contentClass: PropTypes.string,
  darkTitle: PropTypes.bool,
  secondary: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.object,
  ]),
  sx: PropTypes.object,
  contentSX: PropTypes.object,
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.object,
  ]),
};

SubCard.defaultProps = {
  content: true,
};

export default SubCard;
